module.exports = __webpack_public_path__ + "static/img/A7S.ba3ec44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/A7S.png
// module id = 67
// module chunks = 1